import ProjectCard from '../components/ProjectCard'

import '../css/Projects.css'

import { ProjectData } from '../data/ProjectData'

const Projects = () => {
  return (
    <div className="content">
      <div className="introduction">
        <h1>Projects</h1>
      </div>
      <div className="cards">
        {ProjectData.projectsInfo.map((item) => {
          return (
            <a href={item.url}>
              <ProjectCard
                key={item.name}
                name={item.name}
                img={item.img}
                keyword={item.keyword}
              />
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default Projects
